// extracted by mini-css-extract-plugin
module.exports = {"banner":"bM_J","title":"bM_p","description":"bM_h"};